import { useEffect, useState } from 'react'
import { colors } from '../../constants'

const initial = [colors.red, '#2f9b8f', colors.bluelight, colors.orange, colors.red, '#bb5ee0', '#56bbc5']
let colorPalette = [...initial]

function getColor() {
    if (!colorPalette.length) {
        colorPalette = [...initial]
    }

    return colorPalette.shift()
}

function useColors(numColors = 1) {
    const [selectedColors, setSelectedColors] = useState([])

    useEffect(() => {
        const selection = []

        for (let i = 0; i < numColors; i += 1) {
            const c = getColor()
            selection.push(c)
        }

        setSelectedColors(selection)
    }, [numColors])

    return selectedColors
}

export default useColors
